// extracted by mini-css-extract-plugin
export var container = "PublisherDeveloperSubForm-module__container___hR5Fa";
export var dynamicContainer = "PublisherDeveloperSubForm-module__dynamicContainer___L-vnh";
export var large = "1084px";
export var medium = "860px";
export var option = "PublisherDeveloperSubForm-module__option___nI1mN";
export var optionMargin = "PublisherDeveloperSubForm-module__optionMargin___ZtxOc";
export var optionsGroups = "PublisherDeveloperSubForm-module__optionsGroups___EOWEo";
export var small = "540px";